<script setup>
import { computed } from 'vue'
import ArtistBlock from '@components/artist/artist-block'
import { getNextOccurrence, formatNextEpisodeDetails } from '@utils/show-schedule'

const props = defineProps({
    show: {
        type: Object,
        default: () => {},
    },
    artists: {
        type: Array,
        default: () => [],
    },
})

const nextEpisodeDetails = computed(() => {
    if (props.show?.status !== 'open') return null

    const nextEpisodeDate = getNextOccurrence(props.show.schedule)
    if (!nextEpisodeDate) return null

    return formatNextEpisodeDetails(nextEpisodeDate, props.show.channel)
})
</script>

<template>
    <BaseContent>
        <BaseSection
            padded
            title="The Show"
        >
            <div v-if="show?.summary?.length">
                <p
                    v-safe-html="show?.summary"
                    class="info"
                />
            </div>
            <div v-else>
                <p>This show does not have a summary yet.</p>
            </div>
        </BaseSection>
        <BaseSection
            v-if="nextEpisodeDetails"
            padded
            title="Show Schedule"
        >
            <p class="schedule">
                <span class="label">Next Episode:</span> {{ nextEpisodeDetails }}
            </p>
        </BaseSection>
        <BaseSection
            v-if="artists.length"
            padded
            title="Hosts"
        >
            <ArtistBlock
                :artists="artists"
                wrapping
            />
        </BaseSection>
    </BaseContent>
</template>

<style lang="scss" scoped>
@import '@design';

// Multi-column suits the summary's several paragraphs; a one-line sentence would just get
// split across the columns, so the schedule line stays out of it.
.info {
    columns: 320px 2;
    column-gap: $s-m * 2;
    white-space: pre-line;
}

.schedule {
    margin: 0;

    .label {
        font-weight: bold;
        color: $c-white;
    }
}
</style>
